export default function TermsOfServiceRoute() {
	return (
		<main className="container mx-auto mt-24 flex items-center justify-center p-4">
			<iframe
				src="https://www.termsfeed.com/live/45acb3bf-2af1-4fc2-947f-1dcbabcd5cfd"
				className="h-[600px] w-full max-w-[1000px] sm:h-[800px] md:h-[1000px] lg:h-[1100px] xl:h-[1200px]"
			></iframe>
		</main>
	)
}
